
import Img, { ImgProps } from 'react-cool-img';

const TarotImage = (props: ImgProps): JSX.Element => (
  <Img {...props} />
);

export default TarotImage;
